import { API_URL } from '@/const';

export default {
    computed: {
        apiUrl: () => API_URL,
    }
}